import { useMemo } from "react";
import { useLocation } from "react-router-dom";
export function useLocationSegments() {
    const location = useLocation();
    const segments = useMemo(() => location.pathname.split("/").filter((segment) => !!segment), [location]);
    return useMemo(() => ({ segments }), [segments]);
}
